import DemoWrapper from "../../utils/DemoPageWrapper";
/* eslint-disable import/no-webpack-loader-syntax */
import Demo from "./demo.vue";
import DemoSource from "!!raw-loader!./demo.vue";

const config = {
  props: [
    {
      prop: "label",
      description: "checkbox标签文本",
      type: "String",
      required: "是"
    },
    {
      prop: "size",
      description: "尺寸",
      type: "String",
      available: "mini/small/default/middle/large",
      default: "default"
    },
    {
      prop: "value",
      description: "check值",
      type: "Boolean",
      required: "是"
    },
    {
      prop: "disabled",
      description: "是否为禁用状态",
      type: "Boolean",
      default: "false"
    },
    {
      prop: "theme",
      description: "样式主题，目前可选border,fill",
      type: "String",
      default: "border",
      available: "border, fill"
    },
    {
      prop: "indeterminate",
      description: "是否为部分选中态",
      type: "Boolean",
      default: "false"
    }
  ],
  events: [
    {
      name: "change",
      description: "checkbox值变更额外事件",
      argument: "value: 变更值"
    }
  ],
  methods: [],
  slots: []
};

export default DemoWrapper(Demo, DemoSource, config);
